class ShippingInformationService extends BaseService
	@registerService()
	@inject 'ShippingInformationRepository',
		'CredentialsManager'
		'API_ENDPOINT'

	search: (filter, withCounts = false) ->
		filter.page ?= 1
		filter.page_size ?= @ShippingInformationRepository.pageSize

		query = @ShippingInformationRepository.createQuery()
		query.sortBy 'create_time', 'DESC'
		query.setPagination (filter.page - 1) * filter.page_size, filter.page_size
		query.criteria 'shipping_method_id', '=', filter.shipping_method_id

		if withCounts
			@ShippingInformationRepository
				.getEntitiesWithCount query
				.then (response) =>
					filter.count = response.count

					@parseData(response.data)

					return response.data
		else
			@ShippingInformationRepository
				.getEntities query
				.then (response) =>
					@parseData(response)

					return response

	getOrderLink: (orderId) ->
		resourceToken = @CredentialsManager.getResourceToken()

		return "#{@API_ENDPOINT}/render/pdf/orders/#{orderId}?access_token=#{resourceToken}"

	parseData: (response) ->
		for shipping in response
			shipping.type = shipping.entity_type
			shipping.order_link = @getOrderLink(shipping.order_id)
